import m from "../../es2015/lang/th_TH";
window.am4lang_th_TH = m;


//////////////////
// WEBPACK FOOTER
// ./lang/th_TH.js
// module id = null
// module chunks = 